<template>
  <div class="page-wrapper">
    <div class="title">
      <div @click="onBack">
        <van-icon name="arrow-left" style="margin-right: 1.3333vw; vertical-align: middle" />{{ $t('newsDetails')
        }}<span v-if="language !== 'en-US'">NEWS DETAIL</span>
      </div>
    </div>
    <div class="content">
      <div class="top">
        <div class="content-title">{{ respData.contentTitle }}</div>
        <div class="top-b">
          <div style="display: flex; align-items: center">
            <div class="view-original" v-if="respData.contentOutLink" @click="onViewOriginal">
              <i class="el-icon-top-right"></i>{{ $t('viewOriginalText') }}
            </div>
            <div class="share-btn" @click="onShare">
              <van-icon name="share" />
              {{ $t('share') }}
            </div>
          </div>
          <div class="time">{{ respData.contentDate }}</div>
        </div>
      </div>
      <div class="text" style="padding: 2.8289vh 0" v-html="respData.contentDetails"></div>
      <div class="blank"></div>
    </div>
  </div>
</template>

<script>
import { fetchRecruitmentDetail, fetchNewList } from './model'
export default {
  data() {
    return {
      id: '',
      respData: {},
      language: localStorage.getItem('Language')
    }
  },

  components: {},

  computed: {},

  created() {},

  mounted() {
    this.id = localStorage.getItem('news_id')
    if (this.id) this.init(this.id)
  },
  beforeDestroy() {
    localStorage.setItem('news_id', '')
  },
  methods: {
    onBack() {
      this.$emit('onBack')
    },

    init(id) {
      localStorage.setItem('news_id', id)
      this.id = id
      this.getRecruitmentDetail(id)
      // this.getNewList()
    },
    async getRecruitmentDetail(id) {
      const resp = await fetchRecruitmentDetail(id)
      this.respData = resp.data
    },
    onViewOriginal() {
      if (this.respData.contentOutLink) {
        window.open(this.respData.contentOutLink, '_blank')
      }
    },
    getShareUrl() {
      const route = this.$router.resolve({
        path: '/enterprise-news',
        query: { newsId: this.id, showDetail: true }
      })
      return new URL(route.href, window.location.href).href
    },
    onShare() {
      const url = this.getShareUrl()
      const title = this.respData.contentTitle || document.title
      if (navigator.share) {
        navigator.share({ title, url }).catch(() => {})
        return
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(url)
          .then(() => {
            this.$notify({ type: 'success', message: this.$t('copySuccess') })
          })
          .catch(() => {
            this.$notify({ type: 'warning', message: this.$t('copyFail') })
          })
        return
      }
      console.log('navigator.clipboard.writeText is not supported')
      const textarea = document.createElement('textarea')
      textarea.value = url
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        const copied = document.execCommand('copy')
        console.log('Copied', copied)
        if (!copied) throw new Error('Copy failed')
        else this.$notify({ type: 'success', message: this.$t('copySuccess') })
      } catch (e) {
        this.$notify({ type: 'warning', message: this.$t('copyFail') })
      }
      document.body.removeChild(textarea)
    }
  }
}
</script>
<style scoped lang='scss'>
.page-wrapper {
  height: 100%;
  width: 100%;
  font-family: Microsoft YaHei;
  .title {
    height: 6.8721vh;
    margin: 0 8vw;
    border-bottom: 1px solid #f0f0f0;
    div {
      padding-top: 3.0775vh;
      font-size: 3.5667vw;
      span {
        margin-left: 2.1333vw;
        color: #666;
        font-size: 2.1333vw;
      }
    }
  }
  .content {
    margin: 0 8vw;
    .top {
      margin-top: 2.5vh;
      // border-bottom: 1px solid #f0f0f0;
      .content-title {
        font-weight: 550;
        line-height: 1.5;
        font-size: 4.1667vw;
      }
      .top-b {
        display: flex;
        margin-top: 1.3vh;
        font-size: 3.5667vw;
        margin-bottom: 1.4vh;
        justify-content: space-between;
        .view-original {
          margin-right: 3.2333vw;
          color: #576b95;
          font-size: 3.5667vw;
          i {
            margin-right: 0.8vw;
            font-size: 3.5667vw;
          }
        }
        .share-btn {
          margin-right: 3.2333vw;
          color: #576b95;
          font-size: 3.5667vw;
          display: flex;
          align-items: center;
          van-icon {
            font-size: 3.5667vw;
            margin-right: 0.8vw;
            vertical-align: middle;
          }
        }
        .time {
          color: #b2b2b2;
        }
      }
    }
    .text {
      /deep/ video {
        width: 100%;
      }
      /deep/ img {
        width: 100%;
        // margin-left: -2em;
      }
    }
  }
  .blank {
    height: 2.8289vh;
    min-height: 2.8289vh; /* 确保最小高度 */
    display: block;
  }
}
</style>